export enum Pip {
  hanabiRed1 = "hanabiRed1",
  hanabiYellow2 = "hanabiYellow2",
  hanabiGreen3 = "hanabiGreen3",
  hanabiBlue4 = "hanabiBlue4",
  hanabiWhite5 = "hanabiWhite5",
  hanabiAltWhite6 = "hanabiAltWhite6",
  hanabiAltBlue7 = "hanabiAltBlue7", // Currently unused

  emptySet = "emptySet",
  hashtag = "hashtag",
  infinity = "infinity",
  katakanaHe = "katakanaHe",
  katakanaNu = "katakanaNu",
  moon = "moon",
  rainbow = "rainbow",
  triangle = "triangle",
  unoReverse = "unoReverse",
}
